import PreferencesPage from './Preferences.connect'

export default PreferencesPage
